<template>
    <div class="text-center justify-center mb-15">
      <v-carousel cycle class="p0 m0 my-0 py-0">
      <v-carousel-item src="https://cdn.cloudflare.steamstatic.com/steam/apps/2540810/library_hero.jpg?t=1710396753"
        cover>
        <v-layout justify-center align-center fill-height>
          <v-flex shrink>
            <v-img class="icon" width="500"
              src="https://cdn.cloudflare.steamstatic.com/steam/apps/2540810/logo.png?t=1702709292"></v-img>
              <v-btn width="180px" height="40px" color="primary" @click="$router.push('/NyranSurvivors')" class="mx-3">VIEW</v-btn>
              <v-btn width="180px" height="40px" color="primary" @click="openInNewTab('https://store.steampowered.com/app/2540810/Nyran_Survivors/')" class="mx-3">STEAM
                <v-icon class="ml-1">mdi-steam</v-icon>
              </v-btn>
          </v-flex>
        </v-layout>
      </v-carousel-item>

      <v-carousel-item src="https://cdn.cloudflare.steamstatic.com/steam/apps/378370/library_hero.jpg?t=1702278238" cover>
        <v-layout justify-center align-center fill-height>
          <v-flex shrink>
            <v-img class="icon" width="500"
              src="https://cdn.cloudflare.steamstatic.com/steam/apps/378370/logo.png?t=1702278238"></v-img>
              <v-btn width="180px" height="40px" color="primary" @click="$router.push('/Nomad')" class="mx-3">VIEW</v-btn>
              <v-btn width="180px" height="40px" color="primary" @click="openInNewTab('https://store.steampowered.com/app/378370/Nomad/')" class="mx-3">STEAM
                <v-icon class="ml-1">mdi-steam</v-icon>
              </v-btn>
          </v-flex>
        </v-layout></v-carousel-item>
    </v-carousel>


      <v-col cols="12">
        <h1 class="display-2 font-weight-bold mb-2 mt-3">
          Welcome to Diminished Studios
        </h1>

        <p class="subheading font-weight-regular">
          A video game development studio based in Sheffield, UK.
        </p>
      </v-col>


      <div style="width: 100%;" class="d-flex justify-center align-center">
      <div style="width: 75%;">
        <v-row class="d-flex justify-center align-center" dense>
        <v-col sm="6" lg="4" xl="4" class="d-flex justify-center" v-for="(games, index) in recentGames" v-bind:key="games.name">
          <v-hover v-slot:default="{ hover }">
            <v-card class="d-flex flex-column px-0" :elevation="hover ? 6 : 3" color="primary" @click="openInNewTab(games.url)">
              <!-- <v-img lazy-src="https://picsum.photos/id/11/10/6" src="https://via.placeholder.com/250"></v-img> -->
              <v-img :class="hover ? 'zoom' : ''" :src="games.image"></v-img>
              <p class="homepagecard my-0 py-2 mx-2 text-left justify-center">{{ games.name }}</p>
            </v-card>
          </v-hover>
        </v-col>
      </v-row>
      </div>
      </div>
  
    </div>
</template>

<script>
export default {
  name: 'Home',
  metaInfo: {
    title: 'Diminished Studios',
    titleTemplate: '%s',
    htmlAttrs: {
      lang: 'en-US'
    },
    meta: [
      { charset: 'utf-8' },
      { name: 'description', content: 'A video game studio based in Sheffield, UK' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      {property: 'og:title', content: 'Diminished Studios'},
      { property: 'og:image', content:'https://i.imgur.com/lVLowgo.png'}
    ]
  },
  data: () => ({
    recentGames: [
      { name: 'Nyran Survivors', image: "https://cdn.cloudflare.steamstatic.com/steam/apps/2540810/library_header.jpg", url: "https://store.steampowered.com/app/2540810/Nyran_Survivors/" },
      { name: 'Nomad', image: "https://cdn.cloudflare.steamstatic.com/steam/apps/378370/header.jpg", url: "https://store.steampowered.com/app/378370/Nomad/" },
      { name: 'Discord Community', image: "https://i.imgur.com/hNXzgur.png", url: "https://discord.gg/UcKJdYb4dt" },
    ],
  }),
  methods: {
    openInNewTab(url) {
      window.open(url, '_blank', 'noreferrer');
    },
  },
}
</script>

<style>
.v-image {
  .v-image__image {
    transition: all 0.4s;
  }

  &.zoom {
    .v-image__image {
      transform: scale(1.1);
    }
  }
}

.homepagecard {
  font-size: 16px;
  font-weight: bolder;
}

.homepagecarddesc {
  font-size: 14px;
}

.video{
  background-color: #181818;
  width: 100%;
}
</style>
